import { ColDef, ITooltipParams } from 'ag-grid-community'

const approverGroupColumnDefs = [
  {
    headerName: 'Region',
    field: 'region',
    minWidth: 60,
    width: 200,
    hide: false,
    tooltipField: 'region',
    tooltipValueGetter: (params: ITooltipParams) => {
      return params.data?.region
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Markets',
    field: 'markets',
    width: 140,
    headerTooltip: 'Markets',
    tooltipField: 'markets',
    tooltipValueGetter: (params: ITooltipParams) => {
      return params.data?.markets
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Country',
    field: 'countryCodes',
    width: 240,
    headerTooltip: 'Country Codes',
    tooltipField: 'countryCodes',
    tooltipValueGetter: (params: ITooltipParams) => {
      return params.data?.countryCodes
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Approver Role Title',
    width: 320,
    field: 'roleTitle',
    headerTooltip: 'Approver Role Title',
    tooltipField: 'roleTitle',
    tooltipValueGetter: (params: ITooltipParams) => {
      return params.data?.roleTitle
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Approver Email',
    width: 800,
    field: 'approverDescription',
    headerTooltip: 'Approver Email',
    tooltipField: 'approverDescription',
    tooltipValueGetter: (params: ITooltipParams) => {
      return params.data?.approverDescription
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
] as ColDef[]

export default approverGroupColumnDefs
